import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class TicketLocationApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public list(role: string, listingId: string) {
    const endpoint = `${role}/listings/${listingId}/tickets`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url).then(
      (data: any) => {
        return data;
      },
      (error) => this.Api.handleError(error)
    );
  }

  public save(role: string, productId: string, ticketId: number, ticketData) {
    let endpoint = `${role}/listings/${productId}/tickets`;
    const url = this.commonFunctionService.findApiUrl(role);

    if (ticketId) {
      endpoint += `/${ticketId}`;
      return this.Api.put(endpoint, ticketData, url).then(() =>
        this.Api.handleSuccess('Ticket updated')
      );
    }

    return this.Api.post(endpoint, ticketData, url).then((response) => {
      this.Api.handleSuccess('Ticket added');
    });
  }

  public delete(role: string, productId: string, ticketId: number) {
    let endpoint = `${role}/listings/${productId}/tickets/${ticketId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url).then(() => {
      this.Api.handleSuccess('Ticket deleted');
    });
  }
}
